import React, { useContext } from 'react';
import { Button } from '@ui/buttons';
import { Body1, Heading1 } from '@ui/typography';
import { LanguageContext } from '@contexts'; // Import the context that provides the current language
import * as styles from './RegularHeaderBlock.module.scss';

import { BlockContent } from '@components';
import SkjerBuktaSVG from '../../SkjerBuktaSvg';
import ICurvedIcon from '../../icons/ICurvedIcon';


// Type for localized strings
interface LocalizedString {
    en: string;
    nb: string;
}

interface RegularHeaderBlockProps {
    firstLine: LocalizedString;
    secondLine: LocalizedString;
    text?: any;
    pdf?: any;
    buttonLabels?: LocalizedString[];
    backgroundStyle?: React.CSSProperties;
}

export const RegularHeaderBlock: React.FC<RegularHeaderBlockProps> = ({
    firstLine,
    secondLine,
    text,
    pdf,
    buttonLabels,
}) => {
    const { localize } = useContext(LanguageContext);

    // isPhone
    const [isPhone, setIsPhone] = React.useState(false);
    React.useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 768px)');
        setIsPhone(mediaQuery.matches);
        mediaQuery.addListener((mq) => {
            setIsPhone(mq.matches);
        });
        return () => {
            mediaQuery.removeListener((mq) => {
                setIsPhone(mq.matches);
            });
        };
    }, []);

    return (
        <div className={styles.wrapper} style={{ background: "transparent" }}>
            <div>
                <div className={styles.textWrapper}>
                    <Heading1>
                        {localize(firstLine)}
                        <br />
                        <ICurvedIcon />
                        <span className={styles.secondLine}>{localize(secondLine)}</span>
                    </Heading1>
                    {buttonLabels && buttonLabels.length > 0 && (
                        <div className={styles.buttonWrapper}>
                            {buttonLabels.map((label, index) => (
                                <Button key={index} href="#" withArrow>
                                    {localize(label)}
                                </Button>
                            ))}
                        </div>
                    )}

                    
                </div>

                {isPhone &&
                    <div style={{ marginTop: "1rem", marginBottom: "1rem" }} >
                        <SkjerBuktaSVG />
                    </div>
                }

                {text &&
                    <Body1>
                        <div style={{ maxWidth: "40rem", marginBottom: "1.5rem" }}>
                            <BlockContent blocks={localize(text)} />
                        </div>
                    </Body1>


                }


{pdf && <Button href={pdf.asset.url} size='small'   newTab  withArrow>Se månedens kalender</Button>}

            </div>
            {!isPhone &&
                <div className={styles.imageWrapper}>
                    <SkjerBuktaSVG />
                </div>
            }


        </div>
    );
};
